import { NgModule, InjectionToken, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from './icon.component';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ICONS } from './custom-icons.dictionary';

export const CUSTOM_ICON_ASSET_PREFIX = new InjectionToken<string>('CUSTOM_ICON_ASSET_PREFIX', {
  providedIn: 'root',
  factory: () => '',
});

@NgModule({
  imports: [CommonModule, HttpClientModule, MatIconModule],
  declarations: [IconComponent],
  exports: [IconComponent],
})
export class IconModule {
  private readonly customIcons = CUSTOM_ICONS;
  private readonly assetPrefix = inject(CUSTOM_ICON_ASSET_PREFIX);
  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer
  ) {
    this.customIcons.forEach((customIcon) => {
      this.matIconRegistry.addSvgIcon(
        customIcon.name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          customIcon.src.startsWith('assets/') ? this.assetPrefix + customIcon.src : customIcon.src
        )
      );
    });
  }
}
